(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.cookies = {
    attach: function(context, settings) {

      window.setCookie = function(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        document.cookie = `${cname}=${cvalue};expires=${d.toUTCString()};path=/`;
      };

      window.getCookie = function(cname) {
        var name = cname + '=';
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
          }
        }
        return '';
      };

      window.deleteCookie = function(cname) {
        window.setCookie(cname, null, 0);
      };

      window.showCookieSettings = function() {
        const $popup = jQuery('#sliding-popup');

        if (!($popup.length > 0)) {
          window.deleteCookie('cookie-agreed');
          window.location.reload();
        }

        if ($popup.css('display') === 'none') {
          $popup.css({'display': ''});
        }
        Drupal.eu_cookie_compliance.toggleWithdrawBanner();
        jQuery('.eu-cookie-compliance-content .agree-button').focus();
        jQuery('body').addClass('eu-cookie-compliance-popup-open');
      };

      jQuery(document).ready(function() {
        const $popup = jQuery('#sliding-popup');
        $popup.attr('role', 'dialog');

        // $popup.addClass('loaded');
        // $popup.css({'bottom': '0px'});
        // $popup.unbind();
        // jQuery('.global-footer').append($popup);

        jQuery('#menu-legalfooter--cookie-settings, .cookie-notice-cookie-settings').click(function(e) {
          e.preventDefault();
          window.showCookieSettings();
        });
      });
    }
  };
})(jQuery, Drupal);
